/* eslint-disable max-lines-per-function */
import { AvatarBox } from '@/domain/mitarbeiter/features/anlageassistent/content/Anstellungsverhaeltnis/Fristen/AvatarBox';
import { useFristenContext } from '@/domain/mitarbeiter/features/anlageassistent/content/Anstellungsverhaeltnis/Fristen/context/useFristenContext';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { FristenGrund } from '@/domain/mitarbeiter/features/anlageassistent/utils/constants/fristenGrund';
import { cn } from '@/lib/utils';
import { Button, DataDisplayPlain, Skeleton } from '@e2n/ui/v2';
import { faPenToSquare, faTrashCan } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import dayjs from 'dayjs';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';

export function FristenMobile({ readonly = false }: { readonly?: boolean }) {
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  const { setFristIndex, setOpenEditSheet, setOpenDeleteDialog } =
    useFristenContext();

  return (
    <form.Subscribe
      selector={(state) => state.values.anstellungsverhaeltnis.fristen}>
      {(fristen) =>
        fristen.length > 0 && (
          <div className="flex flex-col gap-4 md:hidden py-6 w-full">
            {fristen.map((frist, index) => (
              <div
                key={index}
                className="grid grid-cols-2 border-b border-neutrals-300 pb-4 gap-4">
                <div className="flex flex-col gap-1">
                  <DataDisplayPlain
                    orientation="vertical"
                    label={t(
                      'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.fristen.form.fristdatum.label',
                    )}
                    item={dayjs(frist.fristdatum).format('DD.MM.YYYY')}
                  />
                </div>
                <div className="flex flex-col gap-1">
                  <DataDisplayPlain
                    orientation="vertical"
                    label={t(
                      'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.fristen.form.grund.label',
                    )}
                    item={
                      <span className="wrap-anywhere">
                        {frist.grund === FristenGrund.ANDERER
                          ? frist.andererGrund
                          : t(
                              `domain.mitarbeiter.create.steps.anstellungsverhaeltnis.fristen.form.grund.options.${frist.grund}`,
                            )}
                      </span>
                    }
                  />
                </div>

                <div className="flex flex-col gap-1">
                  <DataDisplayPlain
                    orientation="vertical"
                    label={t(
                      'domain.mitarbeiter.fristen.erinnerungsZeit.label',
                    )}
                    item={frist.erinnerungsZeit
                      .map((zeit) =>
                        t(
                          `domain.mitarbeiter.fristen.erinnerungsZeit.options.${zeit}`,
                        ),
                      )
                      .join(', ')}
                  />
                </div>
                <div className="flex flex-col gap-1">
                  <DataDisplayPlain
                    orientation="vertical"
                    label={t(
                      'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.fristen.form.erinnerungAn.label',
                    )}
                    item={
                      <Suspense fallback={<Skeleton className="h-8 w-full" />}>
                        <AvatarBox managerIds={frist.erinnerungAn} />
                      </Suspense>
                    }
                  />
                </div>

                <div className="flex flex-col gap-1 col-span-2">
                  <DataDisplayPlain
                    orientation="vertical"
                    label={t(
                      'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.fristen.form.bemerkung.label',
                    )}
                    item={frist.bemerkung || '-'}
                  />
                </div>
                <div
                  className={cn('flex gap-2 col-span-2', readonly && 'hidden')}>
                  <Button
                    iconOnly
                    variant="ghost"
                    onClick={() => {
                      setFristIndex(index);
                      setOpenEditSheet(true);
                    }}>
                    <FontAwesomeIcon icon={faPenToSquare} />
                  </Button>
                  <Button
                    iconOnly
                    variant="ghost"
                    onClick={() => {
                      setFristIndex(index);
                      setOpenDeleteDialog(true);
                    }}>
                    <FontAwesomeIcon
                      icon={faTrashCan}
                      className="text-primary-red-600"
                    />
                  </Button>
                </div>
              </div>
            ))}
          </div>
        )
      }
    </form.Subscribe>
  );
}
